const TITLE_MAX = 72;

function looksLikePromptDump(text: string): boolean {
  if (text.length > TITLE_MAX) return true;
  if (/\n/.test(text)) return true;
  return Boolean(/\b1[.)]\s/.test(text) && /\b2[.)]\s/.test(text));
}

export function summarizePrompt(question: string, max = TITLE_MAX): string {
  const firstLine = question.split(/\r?\n/, 1)[0].replace(/\s+/g, ' ').trim();
  const line = firstLine.replace(/:+$/, '').trim();
  if (!line) return 'Chapter';
  if (line.length <= max) return line;
  const sentence = line.match(/^(.+?[.!?])(\s|$)/);
  if (sentence && sentence[1].length <= max) return sentence[1];
  const cut = line.slice(0, max - 1);
  const at = cut.lastIndexOf(' ');
  return `${(at > 24 ? cut.slice(0, at) : cut).trim()}…`;
}

/** Chapter heading: agent title when short, else first line of the prompt. */
export function chapterDisplayTitle(
  spec: { title?: string },
  question: string,
): string {
  const fromSpec = spec.title?.replace(/\s+/g, ' ').trim() ?? '';
  if (fromSpec && !looksLikePromptDump(fromSpec) && fromSpec !== question.trim()) {
    return fromSpec;
  }
  return summarizePrompt(question);
}

export function chapterSummaryLine(answer: string, max = 160): string {
  const flat = answer.replace(/\s+/g, ' ').trim();
  if (flat.length <= max) return flat;
  return `${flat.slice(0, max - 1)}…`;
}
